import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { AddExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/AddExpression";

export class AddExpressionEditor extends ExpressionRuleEditor<AddExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> + </ExpressionPiece>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
